import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'bb-showcase',
  templateUrl: './showcase.component.html',
  styleUrl: './showcase.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ShowcaseComponent {}
